// Processing step: run the pipeline seam (transcribe -> extract) then go to review.
//
// Component idiom: the KareHero MUI design system (branded theme).

import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Container,
  Stack,
  Typography,
} from '@mui/material';
import { useClaimFlow } from './ClaimFlowContext';
import { transcribe, extract } from './pipeline';

const STEPS = [
  'Transcribing the call',
  'Reading the conversation and filling the form',
];

export default function Processing() {
  const navigate = useNavigate();
  const { fileName, setTranscript, setAnswers } = useClaimFlow();
  const [step, setStep] = useState(0);
  const ran = useRef(false);

  useEffect(() => {
    if (!fileName) {
      navigate('/aa-claim', { replace: true });
      return;
    }
    if (ran.current) return;
    ran.current = true;

    (async () => {
      const transcript = await transcribe(null);
      setTranscript(transcript);
      setStep(1);
      const answers = await extract(transcript);
      setAnswers(answers);
      navigate('/aa-claim/review', { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileName]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Container maxWidth='sm'>
        <Stack spacing={3} sx={{ alignItems: 'center', textAlign: 'center' }}>
          <CircularProgress />
          <Typography variant='h6'>{STEPS[step]}</Typography>
          <Typography color='text.secondary'>
            This usually takes a few seconds.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
